<template>
	<div class="fill-window" v-if="isLoading">
		<v-progress-circular indeterminate color="primary"></v-progress-circular>
	</div>
</template>

<script>
export default {
	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {}
	},
}
</script>

<style scoped>
.fill-window {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	z-index: 999;
	background: #7b7b7b57;
}
</style>
